import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { BulkEditState } from './bulkEdit.types';

const initialBulkEditState: BulkEditState = { bulkEdits: [] };

const bulkEditSlice = createSlice({
  initialState: initialBulkEditState,
  name: 'bulkEdit',
  reducers: {
    removeBulkEdit: (state, action) => {
      state.bulkEdits = state.bulkEdits.filter((item) => item !== action.payload);
    },
    resetBulkEdits: (state) => {
      state.bulkEdits = [];
    },
    setAllBulkEdits: (state, action) => {
      state.bulkEdits = action.payload;
    },
    setBulkEdit: (state, action) => {
      state.bulkEdits.push(action.payload);
    }
  }
});

export const selectBulkEdit = (state: RootState) => state.bulkEdit;

export const { removeBulkEdit, resetBulkEdits, setAllBulkEdits, setBulkEdit } =
  bulkEditSlice.actions;

export default bulkEditSlice.reducer;
